import React from 'react';
import Switch from '@material-ui/core/Switch';
import { FormControlLabel } from '@mui/material';

interface Props {
  input: { value: string; onChange: (value: boolean) => void };
  label?: JSX.Element;
  title: JSX.Element;
  disabled: boolean;
  labelClass?: string;
}

const FormSwitch = ({ input, title, label, disabled, labelClass }: Props) => {
  const control = (
    <Switch
      disabled={disabled}
      color="primary"
      checked={input.value || false}
      onChange={(event) => input.onChange(event.target.checked)}
      title={title}
    />
  );
  if (label) {
    return (
      <FormControlLabel
        control={control}
        label={label}
        classes={labelClass ? { label: labelClass } : {}}
      />
    );
  }
  return control;
};

export default FormSwitch;
